module.exports = __webpack_public_path__ + "static/media/load.e6bcebb6.gif";